import { fetchSenders } from 'modules/senders/actions';
import {
  selectAuthedEmailsExist,
  selectSendersExist,
} from 'modules/templatePicker/ducks/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSendersExist = () => {
  const dispatch = useDispatch();

  const smsSendersExist = useSelector(selectSendersExist);
  const authedEmailsExist = useSelector(selectAuthedEmailsExist);

  useEffect(() => {
    dispatch(fetchSenders());
  }, []);

  return { smsSendersExist, authedEmailsExist };
};
